<ui-skeleton-loader-legacy [theme]="{ height: '1.75rem' }" />
